import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Accordion from 'react-bootstrap/Accordion';
import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import { Link } from 'react-router-dom';
const LibrarySpaces = () =>{
    const handleLinkClick = () => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
      };
return (
<div className="RightsandResponsibilities">
    <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/policies.jpg" alt="" />
    </section>
    <section className="research-box-area">
        <Container>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Patron / User Policies</BreadcrumbItem>
            </Breadcrumb>
            <div className='information-content'>
                <h2>Patron / User Policies</h2>
            </div>
            <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                            <div className="flex-column nav nav-pills">
                            <div className="nav-item">
                                    <Link as={Link} to="/BorrowingPolicies" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Borrowing Policies
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerUsePolicy" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Computer Use Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/DiscussionRoomsPolicy" 
                                    onClick={handleLinkClick} className='nav-link' >
                                    Discussion Rooms Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibrarySpaces" 
                                    onClick={handleLinkClick} className='nav-link active'>
                                    Library Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/compliance" 
                                    onClick={handleLinkClick} className='nav-link '>
                                    Compliance
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="policyBox fourth">
                                    <h5>Library Spaces – Norms and acceptable user behaviors</h5>
                                    <p>The norms are being developed based on the core understanding that the library is the heart of Habib University and its core purpose as a space is to promote collaborative learning, individual reflection, studying, and research. Following these norms would make it conducive for every user of the library. </p>
                                    <Accordion >
                                        <Accordion.Item eventKey="01">
                                            <Accordion.Header>Information Commons – Ground Floor</Accordion.Header>
                                            <Accordion.Body>
                                                <h4><span>Core purpose:</span> A social learning, ideas generation, collaborative space, not a relaxation space.</h4>
                                                <div className="zoneChunk">
                                                    <h5><span>Zone 1:</span> Meet up space</h5>
                                                    <p>A space to socialize and share ideas</p>
                                                    <ul>
                                                    <li>Talk, and exchange ideas and jokes, but do not shout.</li>
                                                    <li>Do not use rolling chairs to travel from one place to another.</li>
                                                    <li>No food or snacks are permitted.</li>
                                                    <li>Clean up the space while leaving.</li>
                                                    <li>Do not lie down or sleep on sofas.</li>
                                                    <li>Playing musical instruments or having birthday celebrations is not permitted.</li>
                                                    </ul>
                                                </div>
                                                <div className="zoneChunk">
                                                    <h5><span>Zone 2:</span> Maker Space</h5>
                                                    <p>A space to make/work on new ideas / creative products</p>
                                                    <ul>
                                                    <li>Do not plug in laptops or do floor seating for group discussions here.</li>
                                                    <li>Ask for stationery or other relevant items, if you want to work on a creative idea or manual design-related stuff.</li>
                                                    <li>Clean up while you leave.</li>
                                                    <li>Do not consume any food or beverages.</li>
                                                    <li>Put stationery items back into the trolley after your project is complete.</li>
                                                    </ul>
                                                </div>
                                                <div className="zoneChunk">
                                                    <h5><span>Zone 3:</span> Individual and Group Working Space</h5>
                                                    <p>Study / work options available:</p>
                                                    <ul>
                                                        <li>Individual workspace with desktops.</li>
                                                        <li>One on One work/discussion tables.</li>
                                                        <li>Group work tables and Media scapes (with two LED screens).</li>
                                                        <li>Workspace for laptop users.</li>
                                                        <li>Use designated spaces for individual study with / without laptop.</li>
                                                        <li>Do not move furniture.</li>
                                                        <li>Do not consume any food/snacks or beverages.</li>
                                                    </ul>
                                                </div>
                                                <div className="redNote">
                                                    <p>Do not leave your valuables/bags unattended and always put them in the designated shelves.</p>
                                                    <p>
                                                        When listening to music or watching a documentary/movie or attending online classes, plug in headphones.</p>
                                                    <p>
                                                        Charge your cellphones at charging station located near Touch Screen LCD TV.</p>
                                                    <p>
                                                        PDA is not allowed in the library</p>
                                                    <p>
                                                        Any kinds of games (ludo, cards etc.) are not allowed here.</p>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="02">
                                            <Accordion.Header>Information Commons – First Floor</Accordion.Header>
                                            <Accordion.Body>
                                                <div className="zoneChunk">
                                                    <h5><span>Dawood Habib Yohsin Hall & Asif Aslam Corner</span></h5>
                                                    <h4><span>Core purpose:</span> Silent, contemplative study, reflection, and study space</h4>
                                                    <ul>
                                                        <li>No pairs/group study or talking is permitted at all.</li>
                                                        <li>Do not leave your valuables/bags unattended.</li>
                                                        <li>Cell phones must strictly be on silent. Attend long phone calls outside Yohsin Hall.</li>
                                                        <li>When listening to music or watching a documentary/movie or attending online class, plug in headphones.</li>
                                                        <li>Do not consume any food/snacks or beverages.</li>
                                                        <li>Read and follow signs.</li>
                                                    </ul>
                                                </div>
                                                <div className="zoneChunk">
                                                    <h5><span>Discussion Areas</span> (opposite library offices, front desk, and Discussion rooms)</h5>
                                                    <h4><span>Core purpose:</span> For group study, group assignment preparation only</h4>
                                                    <ul>
                                                        <li>Remember to clean up the space after use.</li>
                                                        <li>Maintain a moderate noise level so other groups can study.</li>
                                                        <li>Select seating as per the number of persons in the group.</li>
                                                        <li>Cell phones must strictly be on silent. Attend phone calls near reception / front desk.</li>
                                                        <li>When listening to music, watching a documentary/movie or attending online class, plug in headphones.</li>
                                                        <li>Do not move furniture/chairs.</li>
                                                        <li>Do not consume any food/snacks or beverages.</li>
                                                        <li>Do not sit between shelves. </li>
                                                    </ul>
                                                </div>
                                                <div className="zoneChunk">
                                                    <h5><span>Discussion Rooms</span> </h5>
                                                    <h4><span>Core purpose:</span> For group study, group assignment preparation, tutorials, project work, and presentations using LCD</h4>
                                                    <ul>
                                                    <li>The maximum number of participants for each room is displayed on the door. Do not include/accommodate more students in the room.</li>
                                                    <li>The rooms have to be booked through the front desk.</li>
                                                    <li>Rooms are not sound-proof, therefore, noise levels should be managed.</li>
                                                    <li>Maximum time limit is 2 hours per day. The extension of hours is at the discretion of the library staff.</li>
                                                    <li>Read and follow signs carefully. Do not violate the norms.</li>
                                                    <li>In case of leaving the room, inform staff. Since there is more demand for rooms, it is strongly recommended that you do not leave your bags and other belongings unattended.</li>
                                                    <li>The rooms are not for any kind of entertainment, games, lunch, snacking or party.</li>
                                                    <li>Listening to any kind of music or watching entertainment movies is not permitted.</li>
                                                    <li>Return the room in the condition it was handed over.</li>
                                                    <li>Do not use rooms for sleeping.</li>
                                                    <li>Rooms will not be issued after 5:00 p.m.</li>
                                                    </ul>
                                                </div>
                                                <div className="zoneChunk">
                                                    <h5><span>Independent Study Area opposite and adjacent to Group discussion rooms, 204 and 205</span> </h5>
                                                    <h4><span>Core purpose:</span> Individual study only</h4>
                                                    <ul>
                                                        <li>No pairs/group study or talking is permitted at all.</li>
                                                        <li>Cell phones must strictly be on silent. Attend to phone calls in the library office. </li>
                                                        <li>In case of attending online classes, always plug in headphones/ear plugs.</li>
                                                        <li>Do not leave your valuables/bags unattended.</li>
                                                        <li>Do not consume any food/snacks or beverages.</li>
                                                    </ul>
                                                </div>
                                                <div className="redNote">
                                                    <p>Food and snacks are not allowed here because it may invite termites, which could lead to damaging of books and furniture.</p>
                                                    <p>Only properly capped drinks/beverages are permitted.</p>
                                                    <p>Any kinds of games (ludo, cards, scrabble, sequence etc.) are not allowed here.</p>
                                                    <p>Charge your cellphones at the cellphone charging station located on the first floor.</p>
                                                    <p>For taking Naps, move out to the student lounge or girls' common room.</p>
                                                    <p>Do not sit near walkways and between shelves.
                                                    PDA is not allowed in the library.</p>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                </Col>
            </Row>
        </Container>
    </section>
</div>
);
}
export default LibrarySpaces;